import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import withStyles from '../../../../core/isomorphic-style-loader/withStyles';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './AppointmentRecapCard.css' or... Remove this comment to see the full error message
import s from './AppointmentRecapCard.css';
import BookingTime from '../../../Location/BookingTime';
import { isEmptyObject } from '../../../../core/util/object';
import { ASAP_LABEL, ASAP_VALUE } from '../../../../constants/index';
import { EN, SupportedLocale } from '../../../../core/util/localizedStr';

type Props = {
  location: any;
  locale?: SupportedLocale;
  booking: any;
  bookingId?: string;
};

const AppointmentRecapCard = (props: Props) => {
  const { location, booking, locale = EN } = props;

  const { t } = useTranslation('bookingWidget');

  const appointmentDate =
    !isEmptyObject(booking.appointmentTime) && booking.appointmentTime.appointmentDate
      ? booking.appointmentTime.appointmentDate
      : booking.appointmentTime;

  const getBookingInfo = () => {
    if (booking.appointmentType === ASAP_VALUE) {
      return (
        <>
          <div key={1}>{ASAP_LABEL}</div>
          {!!location.telemedSla && (
            <div className={s.bodyCopyFinePrint} key={2}>
              {t('appointmentRecapCard.withinMinute', { count: location.telemedSla })}
            </div>
          )}
        </>
      );
    }

    return (
      <BookingTime
        appointmentDate={moment(appointmentDate)}
        className={s.bookingTimeContainer}
        dayNameClassName={s.bookingDay}
        locale={locale}
        timeClassName={s.bookingTime}
        timeZone={props.location.timeZone}
      />
    );
  };

  return (
    <div className={s.root}>
      <div className={s.image}>
        <img role="presentation" src="/images/icons/not_confirmed.svg" />
      </div>

      <div className={s.info}>
        <div className={s.locationName}>{location.name}</div>
        {getBookingInfo()}
      </div>
    </div>
  );
};

export default withStyles(s)(AppointmentRecapCard);
